export * from './wc-promotion-button';
